import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

import {RegionSelect} from '@/modules/common/components/RegionSelect';
import {SortingDropdown} from '@/modules/common/components/SortingDropdown';

export const DropdownGroup = styled(Stack)`
  ${SortingDropdown} {
    flex: auto 1 1;
  }

  ${RegionSelect} {
    flex: auto 1 1;

    ${({theme}) =>
      theme.respondTo(
        'md',
        css`
          /* Preferring max-width over flex-basis for more fine-tuned balance
         between title and controls in edge cases (very short and very long region names) */
          max-width: 220px;
        `
      )}
  }
`;
